import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, registerLocaleData } from '@angular/common';
// import localePl from '@angular/common/locales/pl';
import localeNl from '@angular/common/locales/nl';
import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { MatNativeDateModule } from '@angular/material/core';
import { MenuComponent } from './menu/container/menu/menu.component';

registerLocaleData(localeNl, 'nl');

@NgModule({
    imports: [
        // BrowserAnimationsModule,
        // ButtonsModule,
        CommonModule,
        HttpClientModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'XSRF-Token',
            headerName: 'XSRF-Token',
        }),
        MatNativeDateModule,
        // MatProgressBarModule,
        RouterModule,
        // SharedModule,
        // LayoutComponent,
        MenuComponent,
        // MenuItemDirective,
        // MenuItemComponent
    ],
    providers: [
    // FrontendDataService,
    // ButtonMenuActionComponent,
    // ContactApi,
    // ContactTypeApi,
    // DomainApi,
    // DomainUserApi,
    // NoticeApi,
    // ProjectApi,
    // ProjectCategoryApi,
    // ProjectMemberApi
    ],
    exports: [
    //     LayoutComponent,
    //     MenuComponent,
    ]
})

export class CoreModule { }
